import React from 'react'
import selectThumbnail from '../../../../../img/contact.png'

import './style.scss'

const Index = () => {
    return(
        <div className="empty-contact-container">
            <div className="inner-empty-contact-container">
                <img alt="Ingen kunde" className="empty-illustration" src={selectThumbnail}/>
                <h2 className="empty-title">Ingen kontakter lagt til</h2>
                <p className="empty-description">Det ser ikke ut som du har lagt til noen kontakter enda. Her vil mer detaljert informasjon om hver spesifikk kontakt vises, gjennom valg fra menyen til venstre.</p>
            </div>
        </div>
    )
}

export default Index